export enum ConsentType {
  REGISTRATION = 1,
  MANAGE_MEMBER = 2,
  REGISTER_INBOX = 3,
  REGISTER_WHATSAPP = 4,
}

export interface Consent {
  id: string;
  type: ConsentType;
  text: string;
  title?: string;
  description?: string;
  version?: string;
  effectiveDate?: string;
  createdAt?: string;
  createdBy?: string;
  updatedAt?: string;
  memberName?: string;
  content?: {
    title?: string;
    description?: string;
    version?: string;
    effectiveDate?: string;
    createdAt?: string;
    createdBy?: string;
    updatedAt?: string;
  };
}
